<template>
  <section class="layout-container"
           :id="info.id"
           :class="{ border: isEditMode }">
    <!-- 编辑模式 -->
    <template v-if="isEditMode">
      <swiper class="move"
              :options="swiperOption"
              ref="mySwiper">
        <swiper-slide v-for="(item, index) in info.list"
                      :key="index">
          <img class="pic"
               :src="
              item.src +
              '&imageMogr2/thumbnail/2000x2000/format/' +
              $pic_type +
              '/interlace/1'
            "
               alt="" />
        </swiper-slide>
        <div v-show="info.indicator"
             class="swiper-pagination"
             slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </template>

    <!-- 渲染模式 -->
    <template v-else>
      <swiper :options="swiperOption"
              ref="mySwiper">
        <swiper-slide v-for="(item, index) in info.list"
                      :key="index">
          <img class="pic"
               :src="
              item.src +
              '&imageMogr2/thumbnail/2000x2000/format/' +
              `${
                item.src.toLowerCase().indexOf('gif') < 0 ? $pic_type : 'gif'
              }` +
              '/interlace/1'
            "
               @click="link(item.link)"
               alt="" />
        </swiper-slide>
        <div v-show="info.indicator"
             class="swiper-pagination"
             slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </template>
  </section>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  /******************************************
  ** 轮播组件
  * @description 轮播组件
  * @author stone
  *****************************************
  info            Object             属性样式数据
  isEditMode      Boolean            是否编辑模式
  *****************************************/
  name: 'swipeLayout',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    info: {
      type: Object
    },
    isEditMode: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      swiperOption: {
        autoplay: this.info.autoplay
          ? {
            delay: this.info.interval * 1000
          }
          : false,
        observer: true,
        autoHeight: true,
        loop: true,
        observeSlideChildren: true,
        allowTouchMove: !this.isEditMode,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  watch: {
    autoplay (v, o) {
      if (v) {
        this.swiper.params.autoplay.delay = this.info.interval * 1000
        this.swiper.autoplay.start()
      } else {
        this.swiper.autoplay.stop()
      }
    },
    interval (v, o) {
      this.swiper.params.autoplay.delay = v * 1000
      this.swiper.update()
    },
    indicator (v, o) {
      this.swiper.init()
    }
  },
  computed: {
    autoplay () {
      return this.info.autoplay
    },
    indicator () {
      return this.info.indicator
    },
    interval () {
      return this.info.interval
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    link (url) {
      console.log('=====link', url)
      if (url) {
        if (url.indexOf('https://') !== -1) {
          window.location.href = url
        } else {
          window.location.href = 'https://' + url
        }
      }
    }
  },
  mounted () { }
}
</script>
<style lang="scss" scoped>
.layout-container {
  width: 100%;
  .border {
    border: 1px solid transparent;
  }
  .pic {
    width: 100%;
    display: block;
    transform: scale3d(1, 1, 1);
  }
}
</style>
